var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditCampaignIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95272 13.8986L6.4353 2.63299L7.53363 2.27051L11.0001 13.3644L10.8888 13.5886L9.95272 13.8986Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17836 15.6205L0.711914 4.52655L1.81488 4.16406L5.33693 15.4297L4.4008 15.7349L4.17836 15.6205Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.709815 4.52599L1.06445 5.66113L7.88515 3.40405L7.53051 2.2689L0.709815 4.52599Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79222e-05 2.25743L0.354736 3.39258L7.17544 1.13549L6.8208 0.00034589L9.79222e-05 2.25743Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69736 14.0914L4.052 15.2266L10.8727 12.9695L10.5181 11.8343L3.69736 14.0914Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18872 16.1537L10.4811 14.4033L9.73495 15.901L6.64852 16.9216L5.18872 16.1537Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65869 17.4563L8.187 16.3975L8.87287 15.0191L9.9712 12.8203L11 13.364L10.8888 13.5882L10.481 14.4038L9.73485 15.9014L9.6607 16.0541L9.24361 16.8887L9.21581 16.9412L8.6875 18L7.65869 17.4563Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17847 15.6202L4.70677 14.5566L6.75049 15.6393L8.18712 16.3977L8.20565 16.4072L9.21593 16.9414L8.68762 18.0002L4.17847 15.6202Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCampaignIcon);
export default __webpack_public_path__ + "static/media/edit-campaign-icon.52a307d098fa2383056b24f379ba0b47.svg";
export { ForwardRef as ReactComponent };